import Alerts from './alerts.container';

export default Alerts;
